import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';

import Logger from 'utils/Logger';

import { useFunnelStorage } from '../../storage/Storage';
import { generateSafeUrl, STEP_KEY } from '../../utils';
import PageTransition from '../common/PageTransition/PageTransition';

import { CHOICES, SUB_ROUTES } from './constants';
import Treatment from './substeps/Treatment';
import Urgent from './substeps/Urgent';

const ReasonDetails = ({ position, moveToNextStep }) => {
  const storage = useFunnelStorage();
  const history = useHistory();
  const location = useLocation();
  const { url } = useRouteMatch();

  const safeUrl = generateSafeUrl(url);

  const reasonSelection = storage.get(STEP_KEY.REASON);

  const handleSubStep = () => {
    if (!reasonSelection?.isUrgent) {
      Logger.error('Reason Details was reached without Reason being filled.');
      return;
    }

    setSubStep(
      reasonSelection.isUrgent === 'Yes'
        ? CHOICES.URGENT_ISSUE
        : CHOICES.SPECIFIC_TREATMENT,
    );
  };

  useEffect(() => {
    const userUsedBrowserButtons = history.action === 'POP';

    if (!userUsedBrowserButtons) {
      handleSubStep();
    }
  }, []);

  useEffect(() => {
    // If the user ends up on the main reason details page, redirect them to the correct substep
    if (location.pathname === safeUrl) {
      handleSubStep();
    }
  }, [history, location]);

  const setSubStep = subStep => {
    const subRouteFullPath = subStep
      ? `${safeUrl}${SUB_ROUTES[subStep].path}/`
      : safeUrl;

    if (history.location.pathname !== subRouteFullPath) {
      history.replace(subRouteFullPath);
    }
  };

  return (
    <PageTransition id={location.pathname.split('/')[3]}>
      <Switch location={location}>
        <Route
          path={`${safeUrl}${SUB_ROUTES[CHOICES.SPECIFIC_TREATMENT].path}`}
          render={() =>
            <Treatment position={position} moveToNextStep={moveToNextStep} />
          }
        />
        <Route
          path={`${safeUrl}${SUB_ROUTES[CHOICES.URGENT_ISSUE].path}`}
          render={() =>
            <Urgent position={position} moveToNextStep={moveToNextStep} />
          }
        />
      </Switch>
    </PageTransition>
  );
};

ReasonDetails.propTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
};

export default ReasonDetails;
